<template>
<div class="chapter">
<div class="inner_page">
<div class="Part"><div class="partHead" id="pt01"><a id="page1">
</a><h2 class="partNumber"><a id="page1"><span class="xrefInternal"></span></a><a href="#/9780061737190_contents#pt_01"><span class="bold">part one</span></a></h2>
<h2 class="partTitle"><span class="xrefInternal"><a href="#/9780061737190_contents#pt_01"><span class="bold">BLUE</span></a></span></h2>
<p class="partSubtitle"><span class="xrefInternal"><a href="#/9780061737190_contents#pt_01">1981, 1983, 1987</a></span></p>
<a id="page2"></a></div></div><a id="page2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061737190_part_01.vue?c6b8d686